// The typed collection an event type is served under: v1/orgs/{orgId}/events/{collection}.
const EVENT_COLLECTIONS = { game: 'games', pract: 'practices' }

const eventCollection = (eventTypeCode) => {
  const collection = EVENT_COLLECTIONS[eventTypeCode]
  if (!collection) throw new Error(`Unknown event type: ${eventTypeCode}`)
  return collection
}

export default eventCollection
